import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Register auth-token interceptor at module load so it is active BEFORE any
// child component's useEffect fires. Previously this was registered inside
// AuthProvider's useEffect, which fires AFTER children's effects (React fires
// child effects before parent effects on mount), causing the first admin API
// calls on a hard page reload of /admin to be sent without the Authorization
// header — resulting in 401 → auto-logout → redirect to /admin/login.
api.interceptors.request.use((config) => {
  try {
    const t = typeof window !== "undefined" ? window.localStorage.getItem("ez_admin_token") : null;
    if (t) config.headers.Authorization = `Bearer ${t}`;
  } catch (_) { /* noop */ }
  return config;
});
